// extracted by mini-css-extract-plugin
export var image = "cta-module--image--0b815";
export var root = "cta-module--root--0aa02";
export var subtitle = "cta-module--subtitle--25302";
export var text = "cta-module--text--29cbe";
export var title = "cta-module--title--a7968";
export var wrap = "cta-module--wrap--0d477";